import { useContext } from 'react'
import { SuggesterSearchContext } from 'src/context/search/SuggesterSearch'

export const useSuggesterSearch = () => {
  const suggesterSearch = useContext(SuggesterSearchContext)

  if (!suggesterSearch) {
    throw new Error('Missing SuggesterSearch provider')
  }

  return suggesterSearch
}
